const NOTIFICATION_STATUS = {
  completed: 'COMPLETED',
  fired: 'FIRED',
};

export { NOTIFICATION_STATUS };
